// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  
 firebase : {
    apiKey: "AIzaSyDXPknH9zHrOkbmTFB6w7ptEm4A1jgHwrE",
    authDomain: "cloud-cover-fountane.firebaseapp.com",
    databaseURL: "https://cloud-cover-fountane.firebaseio.com",
    projectId: "cloud-cover-fountane",
    storageBucket: "cloud-cover-fountane.appspot.com",
    messagingSenderId: "716031019898"
  }

};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
